import React from 'react'

import {
  Box,
  Button,
  Display2,
  HeroLayout,
  Link,
  makeStyles,
  useLayoutContext,
  useStaticAssetContext,
} from '@guiker/react-framework'

import { useTranslation } from '../../../hooks'

const useStyle = makeStyles(
  {
    imageContainer: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      height: '100%',
    },
    imageOnTop: {
      width: 609,
      maxWidth: '100%',
    },
  },
  {
    name: 'Services',
  },
)

export const ServicesHeroSection: React.FC = () => {
  const { getAsset } = useStaticAssetContext()
  const assets = getAsset('services')

  const classes = useStyle()
  const { t } = useTranslation(['webapp', 'common'])
  const { isMobile } = useLayoutContext()

  return (
    <HeroLayout
      left={
        <>
          <Display2>{t('services.hero.header')}</Display2>
          <Link color={'info'} isExternalLink to='mailto:support@guiker.com' hoverUnderline={false}>
            <Button size='large' fullWidth={isMobile}>
              {t('services.hero.cta')}
            </Button>
          </Link>
        </>
      }
      right={
        <Box className={classes.imageContainer}>
          <img src={assets.heroImage} className={classes.imageOnTop} height='auto' />
        </Box>
      }
    />
  )
}
